<template>
  <div v-if="visible" class="template template-minimal">
    <div class="tm-header">
      <h2 class="tm-title">AA 账单</h2>
      <p class="tm-date">{{ dateStr }}</p>
    </div>
    <div v-if="discountSummary" class="tm-discount-info">
      <span>原价 {{ discountSummary.totalOriginal }}</span>
      <span v-if="discountSummary.thresholdDiscount > 0">满减 -{{ discountSummary.thresholdDiscount }}</span>
      <span v-if="discountSummary.couponDiscount > 0">券 -{{ discountSummary.couponDiscount }}</span>
    </div>
    <div class="tm-body">
      <div v-for="(item, i) in resultList" :key="i" class="tm-row">
        <span class="tm-name">{{ item.name }}</span>
        <span class="tm-pay">实付 {{ item.payAmount.toFixed(2) }}</span>
        <span :class="['tm-diff', item.type === '应退' ? 'green' : 'red']">
          {{ item.type }} {{ item.finalAmount.toFixed(2) }}
        </span>
      </div>
    </div>
    <div class="tm-footer">
      <div class="tm-divider"></div>
      <p class="tm-total">合计 {{ totalAmount }} 元</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateMinimal',
  props: {
    resultList: { type: Array, default: () => [] },
    form: { type: Object, default: () => ({}) },
    visible: { type: Boolean, default: false },
    discountSummary: { type: Object, default: null }
  },
  computed: {
    dateStr() {
      return new Date().toLocaleDateString()
    },
    totalAmount() {
      if (this.discountSummary) return this.discountSummary.finalTotal.toFixed(2)
      return this.resultList.reduce((s, r) => s + r.payAmount, 0).toFixed(2)
    }
  }
}
</script>

<style scoped>
.template-minimal {
  width: 375px;
  background: #fff;
  padding: 24px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', sans-serif;
  color: #1a1a1a;
  box-sizing: border-box;
}

.tm-header {
  text-align: center;
  margin-bottom: 20px;
}

.tm-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 4px;
  color: #1a1a1a;
}

.tm-discount-info {
  display: flex;
  gap: 8px;
  justify-content: center;
  font-size: 11px;
  color: #667eea;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #e0e0e0;
}

.tm-date {
  font-size: 12px;
  color: #999;
  margin: 0;
}

.tm-body {
  margin-bottom: 16px;
}

.tm-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.tm-name {
  font-weight: 600;
  min-width: 60px;
}

.tm-pay {
  color: #666;
  font-size: 13px;
}

.tm-diff {
  font-weight: 600;
  font-size: 13px;
}

.tm-diff.green {
  color: #48bb78;
}

.tm-diff.red {
  color: #f56565;
}

.tm-footer {
  text-align: center;
}

.tm-divider {
  height: 1px;
  background: #e0e0e0;
  margin-bottom: 10px;
}

.tm-total {
  font-size: 14px;
  color: #666;
  margin: 0;
}
</style>
